import { jsx as _jsx } from "preact/jsx-runtime";
import { ScheduleXCalendar } from '@/components/calendar/ScheduleXCalendar';
export function WebCalendarTab({ web, clientCompanyId }) {
    return (_jsx("div", { className: "-m-6", children: _jsx(ScheduleXCalendar, { clientCompanyId: clientCompanyId, workspaceId: web.WorkspaceId, webId: web.Id }) }));
}
